import { render } from "./GiveReview.vue?vue&type=template&id=2a8289a3"
import script from "./GiveReview.vue?vue&type=script&lang=js"
export * from "./GiveReview.vue?vue&type=script&lang=js"

import "./GiveReview.vue?vue&type=style&index=0&id=2a8289a3&lang=css"

import exportComponent from "../../../../../../../../../../Users/karimdmai2026/Eurekali-Souverainete/eurekali-b2c/eurekaliHome/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__